import { useState } from 'react'
import {
  Backdrop,
  CircularProgress,
  Grid,
  makeStyles,
  FormControl,
  TextField,
  InputAdornment,
  IconButton,
  Button,
  Dialog,
  DialogContent
} from '@material-ui/core'
import AddIcon from '@material-ui/icons/Add'
import SaveOrCancelButtons from '../../components/saveOrCancelButtons'
import { genBase64 } from '../../common/utils'
import AttachFileIcon from '@material-ui/icons/AttachFile'
import { useSelector } from 'react-redux'

const useStyles = makeStyles((theme) => ({
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: '#fff'
  },
  title: {
    justifySelf: 'end',
    margin: '-5px 15px 20px 5px'
  },
  rowTitle: {
    marginRight: 8,
    marginBottom: 4,
    fontWeight: 'bold',
    fontSize: 14
  },
  commentContainer: {
    border: 'solid 1.5px #ff1744',
    backgroundColor: '#efefef',
    borderRadius: '10px',
    margin: '15px 0px',
    padding: '10px'
  },
  dNone: {
    display: 'none'
  }
}))

const FileInputModal = (props) => {
  const classes = useStyles()

  const formTitle = props.formTitle ? props.formTitle : 'Subir Documento'
  const validFileFormat = props.validFileFormat
  const modalButtonTitle = props.modalButtonTitle ? props.modalButtonTitle : 'Añadir'
  const uploadFile = props.uploadFile
  const buttonSize = props.buttonSize ? props.buttonSize : 'small'

  const [isModalDoctoOpen, setIsModalDoctoOpen] = useState(false)
  const [loading, setLoading] = useState(false)
  const [doctoName, setDoctoName] = useState('')
  const [doctoError, setDoctoError] = useState('')

  const modal = useSelector((state) => state.modal)

  const loadFile = async (event) => {
    setDoctoError('')
    setDoctoName('')
    if (event.target.files.length === 0) return
    setDoctoName(event.target.files[0].name)
  }

  const uploadDocument = async () => {
    const input = document.getElementById('docto')
    if (input.files.length === 0) {
      setDoctoName('')
      setDoctoError('No ha seleccionado un archivo')
      return
    }
    const file = input.files[0]
    if (validFileFormat && ![validFileFormat].includes(file.type)) {
      setDoctoName('')
      setDoctoError(`Solo se permiten archivos ${validFileFormat}`)
      return
    }
    setLoading(true)
    const dataFile = {
      fileName: file.name,
      base64Content: await genBase64(file)
    }
    if (uploadFile) {
      await uploadFile(dataFile).then(() => {
        handleCloseModalDoctos()
      })
    }
    setLoading(false)
  }

  const openFileExplorer = () => {
    document.getElementById('docto').click()
  }

  const handleOpenModalDoctos = () => {
    setIsModalDoctoOpen(true)
  }

  const handleCloseModalDoctos = () => {
    setIsModalDoctoOpen(false)
  }

  return (
    <div>
      <Button
        variant="contained"
        color="secondary"
        size={buttonSize}
        startIcon={<AddIcon fontSize={'small'} />}
        onClick={handleOpenModalDoctos}
      >
        {modalButtonTitle}
      </Button>
      <Dialog
        open={isModalDoctoOpen}
        onClose={handleCloseModalDoctos}
        maxWidth={'md'}
        fullWidth={true}
        fullScreen={modal.isFullscreen}
      >
        <DialogContent>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <h2>{formTitle}</h2>
            </Grid>
            <Grid item xs={12}>
              <FormControl fullWidth disabled error={doctoError !== ''}>
                <TextField
                  type="text"
                  value={doctoName}
                  helperText={doctoError}
                  error={doctoError !== ''}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton
                          size="medium"
                          aria-label="toggle password visibility"
                          edge="end"
                        >
                          <AttachFileIcon />
                        </IconButton>
                      </InputAdornment>
                    )
                  }}
                  label="Seleccione un archivo"
                  onClick={openFileExplorer}
                  size="medium"
                  variant="outlined"
                />
              </FormControl>
              <input
                type="file"
                accept={validFileFormat}
                id="docto"
                name="docto"
                className={classes.dNone}
                onChange={loadFile}
              />
            </Grid>
            <SaveOrCancelButtons
              onSave={uploadDocument}
              onCancel={handleCloseModalDoctos}
              loading={loading}
            />
          </Grid>
          <Backdrop className={classes.backdrop} open={loading} onClick={handleCloseModalDoctos}>
            <CircularProgress color="inherit" />
          </Backdrop>
        </DialogContent>
      </Dialog>
    </div>
  )
}

export default FileInputModal
